export default "__VITE_ASSET__BPK1rGsj__"